// Copyright (c) 2016 Deere & Company

import KeyValuePairCollection, {getDefaultState as getKeyValueCollectionDefaultState} from './key-value-pair-collection';
import t from 'tcomb';

const Part = t.struct({
    partDescription: t.String,
    partNumber: t.String,
    unit: KeyValuePairCollection
}, {
    name: 'Part',
    strict: true
});

export const getDefaultState = () => new Part({
    partDescription: '',
    partNumber: '',
    unit: getKeyValueCollectionDefaultState()
});

export default Part;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/part.js